// @flow
export const dataKey: 'purchases_by_group_complexes_2' = 'purchases_by_group_complexes_2';
